export const OMNI = 'OMNI_DISPATCH';

